import React, { useReducer } from "react";

const PageContext = React.createContext();
let PageContextConsumer = PageContext.Consumer;

const initialState = {
  pageSettings: null,
};

let reducer = (state, action) => {
  switch (action.type) {
    // Set the settings for the current page
    case "PAGE-SET-SETTINGS":
      return {
        ...state,
        pageSettings: {
          ...state.pageSettings,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

/**
 * Global context used to be sharing props regarding settings, constraints, boards, etc
 * @param {*} props
 */
const PageContextProvider = (props) => {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = { state, dispatch };

  return (
    <PageContext.Provider value={value}>{props.children}</PageContext.Provider>
  );
};

export { PageContext, PageContextProvider, PageContextConsumer };
